import { ShieldAlert } from "lucide-react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Card, FieldLabel } from "./controls";

export const RiskTab = ({ s, setS }) => (
  <Card icon={ShieldAlert} iconClass="text-orange-600" title="Motor de Alertas de Riesgo" subtitle="Detecta números con exposición peligrosa antes del sorteo." testId="settings-card-risk">
    <div className="flex items-center justify-between gap-3 py-2 border-b border-slate-100">
      <div>
        <Label className="text-sm font-semibold text-slate-900">Habilitado</Label>
        <div className="text-xs text-slate-500">Mostrar banner en el panel cuando se detecten números riesgosos</div>
      </div>
      <Switch checked={!!s.risk_alert_enabled} onCheckedChange={(v) => setS({ ...s, risk_alert_enabled: v })} data-testid="settings-risk-enabled" />
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <FieldLabel title="Umbral % de ventas" hint="Cuando el premio potencial supere este % de las ventas del día" />
        <div className="relative">
          <Input type="number" step="1" min="1" max="500" value={s.risk_alert_pct} onChange={(e) => setS({ ...s, risk_alert_pct: e.target.value })} className="rounded-sm font-mono pr-8" data-testid="settings-pct" />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm font-mono">%</span>
        </div>
      </div>
      <div>
        <FieldLabel title="Piso mínimo (RD$)" hint="No alertar por exposiciones menores a este monto" />
        <Input type="number" step="100" min="0" value={s.risk_alert_min_amount} onChange={(e) => setS({ ...s, risk_alert_min_amount: e.target.value })} className="rounded-sm font-mono" data-testid="settings-min" />
      </div>
    </div>
    <div className="flex items-center justify-between gap-3 pt-2 border-t border-slate-100">
      <div>
        <Label className="text-sm font-semibold text-slate-900">Sugerir límite automáticamente</Label>
        <div className="text-xs text-slate-500">Mostrar botón "Limitar" para aplicar el límite calculado en un clic</div>
      </div>
      <Switch checked={!!s.auto_suggest_limit} onCheckedChange={(v) => setS({ ...s, auto_suggest_limit: v })} data-testid="settings-auto-suggest" />
    </div>
  </Card>
);
